export enum AuthStatus {
  REGISTER = "register",
  VERIFY = "login",
  // Completed employer with no authorized contact — must add one before login.
  AUTHORIZED_CONTACT = "authorized_contact",
}
